<template>
  <div class="container">
    <v-row v-if="loading" class="no-gutters" style="justify-content: center">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </v-row>
    <div v-else-if="configuration && configuration.isActive">
      <v-card
        v-if="toSend"
        class="card-b-radius"
        :style="{
          backgroundColor: configuration.bgColor,
          color: configuration.textColor,
        }"
      >
        <v-card-title>
          <span class="headline" :style="{ color: configuration.titleColor }">{{
            configuration.title
          }}</span>
        </v-card-title>
        <v-card-text class="dynamic-form" :style="dynamicStyles">
          <v-row no-gutters>
            <v-col>
              <div class="ma-1">
                <LabelCustom
                  label="Nome"
                  :color="configuration.textColor"
                ></LabelCustom>
                <v-text-field
                  v-model="response.userName"
                  variant="filled"
                  :rules="[rules.required]"
                  @blur="revalidateFiscalCode"
                ></v-text-field>
              </div>
            </v-col>
            <v-col>
              <div class="ma-1">
                <LabelCustom
                  label="Cognome"
                  :color="configuration.textColor"
                ></LabelCustom>
                <v-text-field
                  v-model="response.userSurname"
                  variant="filled"
                  :rules="[rules.required]"
                  @blur="revalidateFiscalCode"
                ></v-text-field>
              </div>
            </v-col>
            <v-col>
              <div class="ma-1">
                <LabelCustom
                  label="Codice Fiscale"
                  :color="configuration.textColor"
                ></LabelCustom>
                <v-text-field
                  ref="fiscalCodeField"
                  v-model="response.userFiscalCode"
                  variant="filled"
                  :counter="16"
                  :rules="[rules.fiscalCode]"
                  @blur="checkFiscalCode = true"
                ></v-text-field>
              </div>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col>
              <div class="ma-1">
                <LabelCustom
                  label="E-Mail"
                  :color="configuration.textColor"
                ></LabelCustom>
                <v-text-field
                  v-model="response.userEmail"
                  variant="filled"
                  :rules="[rules.required, rules.email]"
                >
                </v-text-field>
              </div>
            </v-col>
            <v-col>
              <div class="ma-1">
                <LabelCustom
                  label="Telefono"
                  :color="configuration.textColor"
                ></LabelCustom>
                <v-text-field
                  v-model="response.userPhoneNumber"
                  variant="filled"
                  :rules="[rules.required, rules.phone]"
                ></v-text-field>
              </div>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col>
              <div class="ma-1">
                <LabelCustom
                  label="Ragione Sociale"
                  :color="configuration.textColor"
                ></LabelCustom>
                <v-text-field
                  v-model="response.userCompanyName"
                  variant="filled"
                  :rules="[rules.required]"
                ></v-text-field>
              </div>
            </v-col>
            <v-col>
              <div class="ma-1">
                <LabelCustom
                  label="Partita IVA"
                  :color="configuration.textColor"
                ></LabelCustom>
                <v-text-field
                  v-model="response.userVatNumber"
                  variant="filled"
                  :counter="11"
                  :rules="[rules.required, rules.vatNumber]"
                ></v-text-field>
              </div>
            </v-col>
            <v-col v-if="configuration.isProvinceRequested" cols="12" md="3">
              <div class="ma-1">
                <LabelCustom
                  label="Provincia"
                  :color="configuration.textColor"
                ></LabelCustom>
                <v-select
                  v-model="response.userProvince"
                  :items="provinces"
                  item-title="name"
                  variant="filled"
                  density="compact"
                  :rules="[rules.required]"
                ></v-select>
              </div>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col
              v-for="(dropdown, index) in configuration.dropdownMenus"
              :key="dropdown.id"
            >
              <div class="ma-1">
                <LabelCustom
                  :label="dropdown.description"
                  :color="configuration.textColor"
                ></LabelCustom>
                <v-select
                  v-model="
                    response.dropdownMenuAnswers[index].dropdownMenuAnswerId
                  "
                  :items="dropdown.answers"
                  item-title="text"
                  item-value="id"
                  variant="filled"
                  density="compact"
                  :rules="[rules.required]"
                ></v-select>
              </div>
            </v-col>
          </v-row>
          <v-row
            v-if="configuration.textField && configuration.textField != ''"
            no-gutters
          >
            <v-col>
              <div class="ma-1">
                <LabelCustom
                  :label="configuration.textField"
                  :color="configuration.textColor"
                ></LabelCustom>
                <v-textarea
                  v-model="response.textFieldAnswer"
                  rows="2"
                  :rules="[rules.required]"
                >
                </v-textarea>
              </div>
            </v-col>
          </v-row>
          <v-row no-gutters class="ma-1">
            <span class="privacy-text">
              Leggi la nostra
              <a
                class="privacy-link"
                :href="computedPrivacyText.link"
                :style="{ color: configuration.textColor }"
                target="_blank"
                >informativa sulla privacy
              </a>
              {{ computedPrivacyText.text1 }}
              <a
                class="privacy-link"
                href="mailto:privacy@euroconference.it"
                :style="{ color: configuration.textColor }"
                target="_blank"
              >
                privacy@euroconference.it
              </a>
              {{ computedPrivacyText.text2 }}
            </span>
            <div class="consense-block">
              <v-checkbox
                v-model="response.submitPersonalData"
                color="white"
                :rules="[rules.required]"
                class="error-above"
                density="compact"
              >
                <template #label>
                  <LabelCustom
                    label="ho letto e compreso l'informativa sul trattamento dei miei dati personali"
                    :color="configuration.textColor"
                  />
                </template>
              </v-checkbox>
              <v-checkbox
                v-model="response.submitECOffers"
                color="white"
                class="no-error"
                density="compact"
              >
                <template #label>
                  <LabelCustom
                    label="desidero rimanere aggiornato su novità e offerte commerciali di prodotti e servizi Euroconference"
                    :color="configuration.textColor"
                    :is-required="false"
                  />
                </template>
              </v-checkbox>
              <v-checkbox
                v-model="response.submitTSOffers"
                color="white"
                class="no-error"
                density="compact"
              >
                <template #label>
                  <LabelCustom
                    :label="computedPrivacyText.checkbox3"
                    :color="configuration.textColor"
                    :is-required="false"
                  />
                </template>
              </v-checkbox>
            </div>
          </v-row>
          <v-row
            no-gutters
            style="justify-content: center; margin-top: 5px; margin-bottom: 5px"
          >
            <v-tooltip v-if="submitDisabled">
              <template #activator="{ props }">
                <v-btn
                  v-bind="props"
                  :color="configuration.buttonColor"
                  :flat="true"
                >
                  <span :style="{ color: configuration.textButtonColor }">
                    {{ configuration.buttonLabel }}
                  </span>
                </v-btn>
              </template>
              <span>Per inviare risolvere le seguenti problematiche:</span>
              <ul>
                <li v-for="error in errors" :key="error.id">
                  <span>{{ error.message }}</span>
                </li>
              </ul>
            </v-tooltip>
            <v-btn v-else :color="configuration.buttonColor" @click="submit">
              <span :style="{ color: configuration.textButtonColor }">
                {{ configuration.buttonLabel }}
              </span>
            </v-btn>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card
        v-else
        class="card-b-radius thank-page"
        :style="{
          backgroundColor: configuration.bgColor,
          position: 'relative',
        }"
      >
        <v-card-title>
          <p
            class="headline"
            :style="{
              color: configuration.textColor,
              whiteSpace: 'pre-line',
              margin: '10px 0 10px',
            }"
          >
            {{ sentMessage }}
          </p>
        </v-card-title>
        <v-btn
          v-if="showOkBtn"
          :style="{
            position: 'absolute',
            bottom: '10px',
            right: '10px',
            backgroundColor: configuration.buttonColor ?? 'white',
            color: configuration.textButtonColor ?? 'black',
          }"
          @click="toSend = true"
          >OK</v-btn
        >
      </v-card>
    </div>
  </div>
</template>
<script>
import LabelCustom from './LabelCustom.vue'
import { getErrorColor } from '@/common/colorUtils'

//Test: ZZZSRG60C17D467U 3351231384 02731000127 test@test.com
export default {
  components: {
    LabelCustom,
  },
  data() {
    const configuration = {
      bgColor: '#1867C0',
      textColor: '#FFFFFF',
    }
    const response = {
      dropdownMenuAnswers: [],
    }
    const provinces = []
    return {
      configuration,
      response,
      provinces,
      validBitObj: {
        phone: false,
        fiscalCode: false,
        mail: false,
        vatNumber: false,
      },
      loading: true,
      toSend: true,
      sentMessage: '',
      showOkBtn: false,
      checkFiscalCode: false,
      rules: {
        required: value => !!value || 'Compila il campo richiesto.',
        phone: value => {
          this.validBitObj.phone = false
          if (value) {
            const pattern = /^[0-9+().\-x\s]*$/
            if (pattern.test(value)) {
              this.validBitObj.phone = true
              return true
            }
            return 'Un numero di telefono valido può contenere solo numeri, +, (, ), -, . o x'
          }
        },
        fiscalCode: v => {
          this.validBitObj.fiscalCode = false
          if (!this.checkFiscalCode) {
            return true
          }
          if (!v) {
            return 'Inserire un codice fiscale valido.'
          }
          if (v && v.length === 16) {
            return this.apiService.usersApi
              .validateFiscalCode(v)
              .then(isValid => {
                if (!isValid) {
                  return 'Il codice fiscale fornito non è valido'
                }
                if (!this.response.userName || !this.response.userSurname) {
                  return true
                }

                const lettersPart = v.substring(0, 6).toUpperCase()
                const fullname = (
                  this.response.userName + this.response.userSurname
                ).toUpperCase()

                for (let char of lettersPart) {
                  if (!fullname.includes(char)) {
                    return 'Il codice fiscale non corrisponde con il nominativo inserito.'
                  }
                }
                this.validBitObj.fiscalCode = true
                return true
              })
          } else {
            return 'Il codice fiscale deve essere di 16 caratteri.'
          }
        },
        email: value => {
          this.validBitObj.mail = false
          if (value) {
            const pattern = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/
            if (pattern.test(value)) {
              this.validBitObj.mail = true
              return true
            }
            return 'Inserisci un indirizzo email valido.'
          }
        },
        vatNumber: value => {
          this.validBitObj.vatNumber = false
          if (value && value.length >= 11) {
            const regex = /^\d{11}$/
            if (regex.test(value)) {
              this.validBitObj.vatNumber = true
              return true
            } else if (value.toUpperCase().startsWith('IT')) {
              return 'Inserire un numero di partita IVA valido (non può iniziare con IT).'
            }
            return 'Inserire un numero di partita IVA valido.'
          } else {
            return 'La partita IVA è composta 11 cifre.'
          }
        },
      },
      privacyTexts: {
        TS: {
          link: 'https://www.euroconference.it/informativa_sulla_privacy',
          text1: `e scegli i consensi che desideri rilasciare a Euroconference,
            titolare del trattamento. Potrai in qualunque momento revocare il
            tuo consenso e opporti al trattamento dei tuoi dati per l'invio di
            comunicazioni commerciali per prodotti e servizi simili a quelli
            utilizzati, inviando un'email a`,
          text2: '.',
          checkbox3:
            'desidero rimanere aggiornato su novità e offerte commerciali delle altre società partner, a cui i miei dati saranno comunicati',
        },
        TS_EC: {
          link: 'https://www.euroconference.it/informativa_sul_trattamento_dei_dati_personali_TeamSystem',
          text1: `e scegli i consensi che desideri rilasciare a Euroconference e TeamSystem,
        contitolari del trattamento. Resta fermo che i contitolari potranno utilizzare
        i tuoi dati personali per le finalità di interesse legittimo così come descritte
        nell'informativa. Potrai in qualunque momento revocare il tuo consenso e opporti
        al trattamento dei tuoi dati per l'invio di comunicazioni commerciali per prodotti
        e servizi simili a quelli utilizzati, inviando un'email a`,
          text2: `o cliccando sul tasto “unsubscribe” che troverai in calce a tutte le nostre comunicazioni.`,
          checkbox3:
            'desidero rimanere aggiornato via e-mail o telefono sulle novità e offerte commerciali di prodotti e servizi TeamSystem',
        },
      },
      privacyMapping: {
        0: 'TS',
        1: 'TS_EC',
      },
    }
  },
  computed: {
    submitDisabled() {
      return (
        !this.isValid(this.response.userName) ||
        !this.isValid(this.response.userSurname) ||
        !this.isValid(this.response.userFiscalCode) ||
        !this.isValid(this.response.userEmail) ||
        !this.isValid(this.response.userPhoneNumber) ||
        !this.isValid(this.response.userCompanyName) ||
        !this.isValid(this.response.userVatNumber) ||
        (this.configuration.isProvinceRequested &&
          !this.isValid(this.response.userProvince)) ||
        (this.configuration.textField &&
          this.configuration.textField != '' &&
          !this.isValid(this.response.textFieldAnswer)) ||
        this.response.dropdownMenuAnswers.some(
          answer => !this.isValid(answer.dropdownMenuAnswerId)
        ) ||
        !this.response.submitPersonalData ||
        Object.values(this.validBitObj).some(bit => !bit)
      )
    },
    errors() {
      const errors = []
      if (!this.isValid(this.response.userName)) {
        errors.push({
          id: 'userName',
          message: 'Nome richiesto.',
        })
      }
      if (!this.isValid(this.response.userSurname)) {
        errors.push({
          id: 'userSurname',
          message: 'Cognome richiesto.',
        })
      }
      if (!this.isValid(this.response.userFiscalCode)) {
        errors.push({
          id: 'userFiscalCode',
          message: 'Codice fiscale richiesto.',
        })
      } else if (!this.validBitObj.fiscalCode) {
        errors.push({
          id: 'fiscalCode',
          message: 'Inserire un codice fiscale valido.',
        })
      }
      if (!this.isValid(this.response.userEmail)) {
        errors.push({
          id: 'userEmail',
          message: 'Email richiesta.',
        })
      } else if (!this.validBitObj.mail) {
        errors.push({
          id: 'mail',
          message: 'Inserire un indirizzo email valido.',
        })
      }
      if (!this.isValid(this.response.userPhoneNumber)) {
        errors.push({
          id: 'userPhoneNumber',
          message: 'Numero di telefono richiesto.',
        })
      } else if (!this.validBitObj.phone) {
        errors.push({
          id: 'phone',
          message: 'Inserire un numero di telefono valido.',
        })
      }
      if (!this.isValid(this.response.userCompanyName)) {
        errors.push({
          id: 'userCompanyName',
          message: 'Nome azienda richiesto.',
        })
      }
      if (!this.isValid(this.response.userVatNumber)) {
        errors.push({
          id: 'userVatNumber',
          message: 'Numero di partita IVA richiesto.',
        })
      } else if (!this.validBitObj.vatNumber) {
        errors.push({
          id: 'vatNumber',
          message: 'Inserire un numero di partita IVA valido.',
        })
      }
      if (
        this.configuration.isProvinceRequested &&
        !this.isValid(this.response.userProvince)
      ) {
        errors.push({
          id: 'userProvince',
          message: 'Provincia richiesta.',
        })
      }
      if (
        this.response.dropdownMenuAnswers.some(
          answer => !this.isValid(answer.dropdownMenuAnswerId)
        )
      ) {
        errors.push({
          id: 'dropdownMenus[0].dropdownMenuAnswerId',
          message: 'Risposta a tutti i dropdown menu richiesta.',
        })
      }
      if (
        this.configuration.textField &&
        this.configuration.textField != '' &&
        !this.isValid(this.response.textFieldAnswer)
      ) {
        errors.push({
          id: 'textFieldAnswer',
          message: 'Risposta al campo di testo richiesta.',
        })
      }
      if (!this.response.submitPersonalData) {
        errors.push({
          id: 'submitPersonalData',
          message: 'Accettazione dei termini e condizioni richiesta.',
        })
      }
      return errors
    },
    dynamicStyles() {
      return {
        '--error-color': getErrorColor(this.configuration.bgColor),
      }
    },
    computedPrivacyText() {
      const key = this.privacyMapping[this.configuration.privacyText] || 'TS'
      return this.privacyTexts[key]
    },
  },
  mounted() {
    const formElement = document.getElementById('dynamic-form')
    const formId = formElement
      ? document.getElementById('dynamic-form').getAttribute('data-form-id')
      : null
    this.loading = true
    this.apiService.dynamicFormsApi
      .getDynamicForm(formId)
      .then(data => {
        if (!data) {
          this.toSend = false
          this.sentMessage =
            'Impossibile caricare il form al momento, riprova più tardi!'
          this.showOkBtn = false
          return
        }
        this.configuration = data
        const dropdownMenuAnswersBase = []
        for (const d of data.dropdownMenus) {
          dropdownMenuAnswersBase.push({
            dropdownMenuId: d.id,
            dropdownMenuAnswerId: null,
          })
        }
        this.response.dropdownMenuAnswers = dropdownMenuAnswersBase
        this.response.dynamicFormId = formId
        this.response.submitECOffers = false
        this.response.submitTSOffers = false
      })
      .catch(() => {
        this.toSend = false
        this.sentMessage =
          'Impossibile caricare il form al momento, riprova più tardi!'
        this.showOkBtn = false
      })
      .finally(() => {
        this.loading = false
      })
    this.apiService.registrationsApi
      .getProvinces()
      .then(list => (this.provinces = list.filter(p => p.name != 'Web')))
  },
  methods: {
    submit() {
      this.loading = true
      const submitData = { ...this.response }
      const dropdownMenuAnswersToSubmit = []
      for (const answer of submitData.dropdownMenuAnswers) {
        if (answer.dropdownMenuAnswerId) {
          dropdownMenuAnswersToSubmit.push(answer)
        }
      }
      submitData.dropdownMenuAnswers = dropdownMenuAnswersToSubmit
      this.apiService.dynamicFormsApi
        .submitDynamicForm(submitData)
        .then(res => {
          this.sentMessage = this.configuration.thankYouText
          this.showOkBtn = false
          if (res <= 0) {
            this.sentMessage =
              'Si è verificato un errore durante il salvataggio della tua risposta. Riprova più tardi.'
            this.showOkBtn = true
          }
        })
        .catch(() => {
          this.sentMessage =
            'Si è verificato un errore durante il salvataggio della tua risposta. Riprova più tardi.'
        })
        .finally(() => {
          this.loading = false
          this.toSend = false
        })
    },
    isValid(value) {
      return value && value != ''
    },
    revalidateFiscalCode() {
      const fiscalCodeField = this.$refs.fiscalCodeField
      if (
        fiscalCodeField &&
        this.response.userName &&
        this.response.userSurname
      ) {
        fiscalCodeField.validate()
      }
    },
  },
}
</script>
<style scoped>
.thank-page {
  text-align: center;
  align-content: center;
  white-space: pre-line;
}
.container {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.privacy-link {
  font-weight: bolder;
}
.privacy-text {
  font-size: small;
}
</style>
<style lang="scss">
.dynamic-form {
  --error-color: var(--error-color);

  .changed {
    background: transparent !important;
  }

  input,
  textarea {
    background-color: transparent !important;
    mask-image: none !important;
    border: 0px !important;
    box-shadow: none !important;
  }

  input {
    height: 100% !important;
    min-height: auto !important;
    margin: 0px !important;
  }

  .v-field__input {
    padding: 0px !important;
  }
  .v-field__field {
    padding: 4px 6px !important;
    height: 30px;
  }

  .v-field {
    background-color: white !important;
    color: black !important;
  }

  .v-select__selection-text {
    height: 30px;
  }

  .v-textarea .v-field__field {
    height: 90%;
    .v-field__input {
      margin-bottom: 0px;
    }
  }

  .v-input__details {
    display: block !important;
    min-height: auto !important;
  }

  .no-error {
    .v-input__details {
      display: none !important;
    }
  }
  .error-above {
    position: relative;
    margin-top: 15px;
    .v-input__details {
      position: absolute;
      bottom: 35px;
    }
  }

  .v-input--error:not(.v-input--disabled) .v-input__details .v-messages,
  .v-field--error:not(.v-field--disabled) .v-field__outline,
  .v-selection-control--error:not(.v-selection-control--disabled)
    .v-selection-control__input
    > .v-icon,
  .v-field--error:not(.v-field--disabled) .v-field__append-inner > .v-icon,
  .required {
    color: var(--error-color) !important;
  }

  .v-checkbox .v-label {
    opacity: 100% !important;
    margin: 0;
    margin-left: 0.5rem;
    font-size: small;
  }

  .v-input__details {
    position: relative;
  }

  .v-counter {
    position: absolute;
    right: 3px;
    top: 7px;
  }
}

.v-list {
  overflow-x: hidden !important;
}
</style>
